<script>
  import BaseModal from "./BaseModal.svelte";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  export let open;
  export let title;
  export let content = null;
  export let contentProps = {};
  export let primaryButtonDisabled = false;
</script>

<BaseModal
  width={400}
  bind:show={open}
  onClose={() => (open = false)}
  {title}
  disableOverlayClose={true}
  bind:primaryButtonDisabled
  on:submit={() => dispatch("submit", contentProps.value)}
>
  {#if typeof content === "string"}
    <div class="message">
      {@html content}
    </div>
  {:else}
    <svelte:component
      this={content}
      bind:value={contentProps.value}
      {...contentProps}
    />
  {/if}
</BaseModal>

<style scoped>
  .message {
    color: #1d2226;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
</style>
